import React from 'react';


export const OrderProcessMessage = () => {
    return <span>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i> We are not processing any orders during the lockdown. All orders placed will be processed once the lockdown is over in KTM Valley.
    </span>
}


export const DesignApprovalMessage = () => {
    return <span>
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i> All uploaded designs will be approved once Seto Canvas office resumes after lockdown is over in KTM Valley.
    </span>
}

const NoticeBanner = ({children}) => {


    return <div className="noticeBanner">
        {children}
    </div>
};

export default NoticeBanner;





// WEBPACK FOOTER //
// ./src/views/NoticeBanner.js